import React from "react";

import CashflowsTab from "./CashflowsTab";

class Cashflows extends React.Component {
  render() {
    return (
      <CashflowsTab />
    );
  }
}

export default Cashflows;
